import { useRouting, useRoutingConfig } from '@rad/hooks/useRouting';
import { resolveBackLink } from '../common/routes/back-link';
// A page's "Back to" link: where the visitor came from when that page has a name, else the fallback the page supplies.
// Returns a resolver because a page may only know its fallback once its data has loaded.
const useBackLink = () => {
    const strategy = useRoutingConfig();
    const [location] = useRouting();
    const origin = strategy.origin();
    return (fallback) => resolveBackLink(strategy.parse, location, origin, fallback);
};
export default useBackLink;
